<template>
  <b-row>
    
  </b-row>
</template>

<script>
import StatisticCardVertical from "./components/StatisticCardVertical.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import UsersController from "@/Controllers/UsersController";
import OnlineSessionController from "@/Controllers/OnlineSessionController";

export default {
  components: {
    StatisticCardVertical,
    StatisticCardHorizontal,
  },
  data() {
    return {
      // Area charts
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      // Line Charts
      siteTraffic: {},
      activeUsers: {},
      newsletter: {},
      users: 0,
      online:0,
    };
  },
  async created() {
    this.users = await new UsersController().getAllOnline({ count: 1 });
    new OnlineSessionController()
      .GetAll({
        count: 1,
        now: true,
      })
      .then((res) => {
        this.online = res;
      });
  },
};
</script>

<style>
</style>